import React from 'react';

class ProfileAd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            profileId: this.props.profileId
        };
    }

    componentDidMount = () => {}

    componentWillReceiveProps = (nextProps) => {
        this.setState({
            profileId: nextProps.profileId
        });
    }

    render() {
        return (
            <div className="page_course_box profile_content_wrapper">
                <img className="profile-ad-img" src="https://media.licdn.com/media/AAYQAgTPAAgAAQAAAAAAADVuOvKzTF-3RD6j-qFPqhubBQ.png" alt="Advertise on LinkedIn" border="0"/>
            </div>
        )
    }
}

export default ProfileAd;


/** WEBPACK FOOTER **
 ** ./src/client/app/appcomponents/commons/profile/profile_ad.js
 **/